<!-- 采购收货数据操作 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <procurementOrderTemplate ref="procurementOrderTemplate" @selectDataAction="selectDataAction">
      </procurementOrderTemplate>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0 && scope.row.isShowForm != 1">
                           <el-form label-width="150px" id="mainInfo" ref="sendDataInfo" label-position="right" :show-message="false" class="demo-form-inline baseForm" :model="sendDataInfo" size="mini">
                              <el-row v-if="dataActionBox.actionType != 2">
                                 <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                               :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []" :prop="formOneValue.entityField">
                                    <!-- 系统字段 -->
                                    <!-- 收货日期orderDate -->
                                    <df-date v-if="formOneValue.fieldType == 'date'" :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1" :isShowLong="false"
                                             v-model="sendDataInfo[formOneValue.entityField]">
                                    </df-date>
                                    <el-tooltip v-else-if="formOneValue.fieldType == 'extract'" class="item"
                                                :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                 @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                                 :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                          <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)" slot="append" icon="el-icon-search"
                                                     :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <el-input clearable :disabled="formOneValue.isChange == 0" v-else v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                       sendDataInfo[formOneValue.entityField]
                                                   }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                       }}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'formatter'">{{
                                                   getValue(sendDataInfo[formOneValue.entityField],
                                                       formOneValue.entityField, formOneValue.fieldType,
                                                       formOneValue.formatterContent) }}</span>
                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <!-- 明细    -->
                           <el-form size="mini" v-if="sendDataInfo.detailList">
                              <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                 <!-- <el-button type="primary" size="mini" @click="deleteDetails()">删除</el-button>
                                <el-button type="primary" size="mini" @click="lookLicence()">查看证照</el-button> -->
                              </div>
                              <el-table size="mini" ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange" :data="sendDataInfo.detailList"
                                        border style="width: 100%" :height="mxHeight">
                                 <el-table-column width="80" label="选择" v-if="dataActionBox.actionType != 2">
                                    <template slot-scope="scope">
                                       <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>
                                 <template v-for="(formOneValue, formOneKey) in mxForm">
                                    <el-table-column :min-width="formOneValue.fieldWeight" align="center" show-overflow-tooltip :prop="formOneValue.entityField" :label="formOneValue.showField" :key="formOneKey"
                                                     v-if="formOneValue.isShow == 1">
                                       <template slot-scope="scope">
                                          <!-- 显示通用名称 -->
                                          <span v-if="formOneValue.isRift == 1">
                                             <a @click="toDetail(scope.row[formOneValue.riftField])">{{
                                                               scope.row[formOneValue.entityField] }}</a>
                                          </span>
                                          <span v-else-if="formOneValue.fieldType == 'date'">
                                             <span v-if="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                                {{   $common.getLocalTime(sendDataInfo.detailList[scope.$index][formOneValue.entityField])   }}
                                             </span>
                                          </span>
                                          <span v-else-if="formOneValue.fieldType == 'dateTime'">
                                             <span v-if="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                                {{  $common.getLocalTime(sendDataInfo.detailList[scope.$index][formOneValue.entityField], true) }}
                                             </span>
                                          </span>
                                          <!-- 备注 -->
                                          <input class="newInput" :ref="formOneValue.entityField" @keyup.enter="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                 v-else-if="formOneValue.entityField == 'psrgdRemark' && dataActionBox.actionType != 2" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                                 :maxlength="$store.state.inputLength" />
                                          <span v-else>
                                             {{
                                                               sendDataInfo.detailList[scope.$index][formOneValue.entityField]
                                                           }}
                                          </span>
                                       </template>
                                    </el-table-column>
                                 </template>
                              </el-table>
                           </el-form>
                        </div>
                        <!-- 冷链信息 -->
                        <div v-if="scope.index == 1 && scope.row.isShowForm != 1">
                           <el-form size="mini" id="coldInfo" class="baseForm" label-width="150px" :show-message="false">
                              <el-row v-if="dataActionBox.actionType != 2">
                                 <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                    <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                       <!-- 系统字段 -->
                                       <div v-if="formOneValue.isReserved == 0">

                                          <el-date-picker clearable :disabled="formOneValue.isChange == 0" @change="timeBlur(formOneKey)" v-if="formOneValue.fieldType == 'date'"
                                                          v-model="sendDataInfo.transport[formOneValue.entityField]" type="date" placeholder="选择日期" value-format="timestamp">
                                          </el-date-picker>
                                          <el-date-picker clearable :disabled="formOneValue.isChange == 0" @change="timeBlur(formOneKey)" v-if="formOneValue.fieldType == 'dateTime'"
                                                          v-model="sendDataInfo.transport[formOneValue.entityField]" type="datetime" placeholder="选择日期" value-format="timestamp">
                                          </el-date-picker>
                                          <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                      :disabled="sendDataInfo.transport[formOneValue.entityField] == null || sendDataInfo.transport[formOneValue.entityField] == '' ? true : false || sendDataInfo.transport[formOneValue.entityField].length <= 9"
                                                      effect="dark" :content="sendDataInfo.transport[formOneValue.entityField]" placement="bottom-start">
                                             <el-input clearable v-model="sendDataInfo.transport[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                       @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                       :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                           :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                </el-button>
                                             </el-input>
                                          </el-tooltip>
                                          <div v-else-if="formOneValue.entityField == 'coldPicture'">
                                             <input style="display: none;" type="file" id="recordExcel" multiple name="recordExcel" @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e) }" />
                                             <ul v-if="sendDataInfo.transport[formOneValue.entityField]" class="upload">
                                                <li v-for="(val,key) in sendDataInfo.transport[formOneValue.entityField]" :key="key">
                                                   <i class="el-icon-error del" @click="delRemove(key)"></i>
                                                   <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                                   </cusImage>
                                                </li>
                                                <li>
                                                   <label for="recordExcel" class="image_label">
                                                      <i class="el-icon-plus icon"></i>
                                                   </label>
                                                </li>
                                             </ul>
                                             <ul v-else class="upload">
                                                <li>
                                                   <label for="recordExcel" class="image_label">
                                                      <i class="el-icon-plus icon"></i>
                                                   </label>
                                                </li>
                                             </ul>
                                          </div>
                                          <el-input clearable v-else @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo.transport[formOneValue.entityField]"
                                                    maxlength="$store.state.inputLength"></el-input>
                                       </div>
                                    </el-form-item>
                                 </template>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                    <span v-if="sendDataInfo.transport">
                                       <span v-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(sendDataInfo.transport[formOneValue.riftField])">{{
                                                               sendDataInfo.transport[formOneValue.entityField] }}</a>
                                       </span>
                                       <span v-else-if="formOneValue.fieldType == 'date'">
                                          <span v-if="sendDataInfo.transport[formOneValue.entityField]">
                                             {{
                                                               $common.getLocalTime(sendDataInfo.transport[formOneValue.entityField])
                                                           }}
                                          </span>
                                       </span>
                                       <span v-else-if="formOneValue.fieldType == 'dateTime'">
                                          <span v-if="sendDataInfo.transport[formOneValue.entityField]">
                                             {{
                                                               $common.getLocalTime(sendDataInfo.transport[formOneValue.entityField],
                                                                   true) }}
                                          </span>
                                       </span>
                                       <div v-else-if="formOneValue.entityField == 'coldPicture'">
                                          <ul v-if="sendDataInfo.transport[formOneValue.entityField]" class="upload">
                                             <li v-for="(val,key) in sendDataInfo.transport[formOneValue.entityField]" :key="key">
                                                <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                                </cusImage>
                                             </li>
                                          </ul>
                                       </div>
                                       <span v-else>{{ sendDataInfo.transport[formOneValue.entityField]
                                                       }}</span>
                                    </span>

                                 </el-form-item>
                              </el-row>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>
            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="addProductFun" @showPrintPlan="showPrintPlan"></v-foot>
         </div>

      </div>
      <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
         <ExtractionScheme ref="extractionScheme" :isChecked="true" :extractParamsData="extractParamsData" :ppId="ppId" :id="exId" @TranData="getExData" @getWidth="getExWidth" @sendTitle="getExtractName" />
      </el-dialog>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
// import SearchScheme from "../byComponents/SearchScheme.vue";
	  import procurementOrderTemplate from "@/components/procurementOrderTemplate.vue";

import NP from "number-precision";
export default {
   name: "mdInListAction",
   props: ['actionData'],
   //import引入的组件需要注入到对象中才能使用
   components: {
      ExtractionScheme,
      SearchScheme,
      procurementOrderTemplate,

   },
   data() {
      //这里存放数据
      return {
         imgUrl: window.global_config.BASE_IMG_URL,
         ppId: "",
         selectedDetailsIndex: 0,
         exTitle: "",
         exWidth: "90%",
         exId: "",
         DialogExtract: false,
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            ormId: "",
            opmId: "",
            smName: "",
            transport: {
               psrgciArrtem: "",
               psrgciArrtime: "",  //到货时间
               psrgciRemark: "",
               psrgciStrantem: "",
               psrgciStrantime: "",    //起运时间
               psrgciTconmode: "",
               psrgciTranmode: "",
               trafficUnit: "",    //运输单位
               haulTool: "",   //运输工具
               hippingLocation: "", //发运地点
               numberPlate: "",    //车牌号
               controlStatus: "",  //温控状况
               highTemperature: "", //在途最高温度
               lowTemperature: "", //在途最低温度
               coldPicture: [],//温湿度
            },
            coId: '',
            coName: '',
            detailList: [],
            psaiId: "",
            deliOmId: "",
            smId: "",
            salesId: "",
            psrgdRecnumber: 0,
            psrgdPsupperlimit: 0,
            salesName: "",
            opmName: "",
            depId: "",
            depName: "",
            psomRemark: "",
            isWms: "",
            totalMoney: "",
            totalCount: "",
            totalNumber: "",
            psomState: "",
            psrgmBuycus: "",
            orderDate: "",
            psaiCarrier: "",
            psaiCarricus: "",
            psrgmReserves1: "",
            psrgmReserves2: "",
            psrgmReserves3: "",
            psrgmReserves4: "",
            psrgmReserves5: "",
            psrgmReserves6: "",
            psrgmSsalesman: "",
         },
         showTabs: "",
         formDataList: [],
         userOneList: [],
         salesmanList: [],
         mxHeight: 0,
         isLoaded: false,
         selectedRow: [], // 当前已选择行
         mainFormList: [], //过滤的主表单
         tabForm: [], // tab循环的主表单
         mxForm: [],
         footForm: [],
         sField: '', // 赋值字段
         fField: '', //焦点字段
         nosField: '', // 不可赋值字段
         inputel: '', //所有input对象
         seTitle: "", //检索
         DialogVisible: false,
         seId: 0,
         seType: "",
         seIndex: 0,
         seWidth: '',
         parentSearchData: {
            storeId: ''
         },
         extractParamsData: {
            storeId: ''
         },
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.detailList": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.detailList.forEach((item, keys) => {
               this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(this.sendDataInfo.totalMoney, item.psmoney))
               this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, NP.plus(this.sendDataInfo.totalNumber, item.dbNum))
            });
            this.sendDataInfo.totalCount = this.sendDataInfo.detailList.length;
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      getValue(val, type, fieldType, arr) {
         var str = ""
         if (fieldType == 'formatter') {
            if (arr) {
               JSON.parse(arr).forEach(item => {
                  if (String(Number(item.value)) != NaN && item.value == val) {
                     str = item.key
                  } else if (String(Number(item.key)) != NaN && item.key == val) {
                     str = item.value
                  }
               })
            }
         } else {
            str = val || ""
         }
         return String(str)
      },
      delRemove(key) {
         this.sendDataInfo.transport.coldPicture.splice(key, 1)
      },
      async fileUpload(files, length, index, e) {
         if (length - 1 >= index) {
            const params = {
               file: files[index]
            }
            const response = await this.$http.uploadFile(params, true)
            if (response.status == 200) {
               this.sendDataInfo.transport.coldPicture.push(response.result[0].fileUrl)
               this.fileUpload(files, length, index + 1, e)
            } else {
               e.target.value = ""
               this.$message.error(response.message)
            }
         } else {
            e.target.value = ""
         }
      },
      tabHeight(val) { this.mxHeight = val },
      // 检索Id, 索引(表格中), 标识
      //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
      openSearch(sId, index, type, sField, fField, nosField) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField
         this.fField = fField
         this.nosField = nosField
         this.parentSearchData[type] = this.sendDataInfo.transport[type]
      },
      changeInputModel(val) {
         // debuggger
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      // 不可赋值字段
      noSetField(val) {
         let arr = this.nosField.split(',')
         arr.forEach(item => {
            this.sendDataInfo.transport[item] = ''
         })
      },

      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo.transport[item] = val[item]
         })
         this.$nextTick(() => {
            this.nextFocus(this.seIndex)
         })
      },

      // 清除赋值字段数据
      clearValue() {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo.transport[item] = ''
         })
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      // 获取冷链表单所有input
      getMainInput() {
         console.log(document.getElementById('mainInfo'));
         var el = document.getElementById('mainInfo')
         if (el) this.inputel = el.getElementsByTagName('input')
      },

      // 主表单select框切换enter切换焦点事件方法
      selectChange(e) {
         if (e == false) {
            for (let index = 0; index < this.inputel.length; index++) {
               if (this.inputel[index] == document.activeElement) {
                  this.nextFocus(index)
                  break
               }
            }
         }
      },
      closeChild() {
         addEventListener('keyup', this.keyUp)//创建监听键盘事件
      },
      // 输入框切换焦点
      nextFocus(index) {
         if (index >= (this.inputel.length - 1)) {
            return
         }
         var aindex = index + 1
         if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
            this.nextFocus(aindex)
            return
         }
         this.inputel[aindex].focus()
      },
      // 时间框失去焦点
      timeBlur(index) {
         this.nextFocus(index)
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == '') {
               this.inputel[index].focus()
               break
            }
         }
      },

      // 表格切换焦点方法
      tableNextFocus(field, index) {
         if (field == 'keydown') {
            if (index == this.sendDataInfo.detailList.length - 1) return
            if (this.sendDataInfo.detailList[index + 1] != undefined) {
               this.$refs['psrgdRecnumber'][index + 1].focus() //跳到货数量
               this.selectedDetailsIndex = index + 1
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]);
               })
               return
            }
         }
         this.$refs[field][index].focus()
      },

      // 监听键盘事件
      keyUp(e) {
         if (e.key == 'F1') { // 右键新增明细
            e.preventDefault();
            // this.addDetail('sendDataInfo')
            return
         } else if (e.key == 'F2') {
            e.preventDefault();
            this.deleteDetails()
         } else if (e.keyCode == 40) { // 下键
            // 表格为空，不执行下方 
            if (this.sendDataInfo.detailList.length == 0) return
            let refsElTable = this.$refs.mxTableRef
            this.$nextTick(() => {
               if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                  this.selectedDetailsIndex = 0
               } else if (this.selectedDetailsIndex == this.sendDataInfo.detailList.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                  this.selectedDetailsIndex = 0
               } else { // 正常递增
                  this.selectedDetailsIndex++
               }
               if (!refsElTable) return
               let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
               //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
               if (findRow && this.selectedRow.length === 1) {
                  refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex], false);
                  return;
               }
               // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]); // 把现在当前行勾选
            })
         } else if (e.keyCode == 38) { // 上键
            if (this.sendDataInfo.detailList.length == 0) return
            let refsElTable = this.$refs.mxTableRef
            this.$nextTick(() => {
               if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                  this.selectedDetailsIndex = 0
               } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                  this.selectedDetailsIndex = this.sendDataInfo.detailList.length - 1
               } else { // 正常递减
                  this.selectedDetailsIndex--
               }
               if (!refsElTable) return
               let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
               //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
               if (findRow && this.selectedRow.length === 1) {
                  refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex], false);
                  return;
               }
               // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]); // 把现在当前行勾选
            })
         }

      },

      // 表格方法
      rowClassName({ row, rowIndex }) {
         let rowName = "",
            findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
         if (findRow) {
            rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
         }
         return rowName; //也可以再加上其他类名 如果有需求的话
      },

      // 选中行底色逻辑
      rowStyle({ row, rowIndex }) {
         Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false
         });
         let rowBackground = {}
         if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
         return rowBackground
      },

      // 明细表格点击选中
      clickEvent(row, column, event, params) {
         let refsElTable = this.$refs.mxTableRef; // 获取表格对象
         let findRow = {}
         this.selectedDetailsIndex = row.rowIndex
         findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
         //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
         if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(row, false);
            return;
         }
         // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
         refsElTable.clearSelection();
         refsElTable.toggleRowSelection(row);
      },

      // 保存已选择行
      handleSelectionChange(rows) {
         this.selectedRow = rows; // 保存已选择行
      },

      // 查看证照
      lookLicence() {
         if (this.sendDataInfo.smId == '') {
            return this.$message({
               message: "暂无采购订单单据信息",
               type: "warning",
            });
         }
         this.$parent.$parent.toDetail(this.sendDataInfo.smId);
      },
      showPrintPlan() { // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
         } else {
            return
         }
      },
      // 子组件穿透
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
         else this.$parent.$parent.$parent.toDetail(orderId)
      },
      // 删除明细
      deleteDetails() {
         if (this.sendDataInfo.detailList.length > 0) {
            if (this.selectedDetailsIndex === "") {
               return this.$message({
                  message: "请先选中明细",
                  type: "warning",
               });
            } else {
               this.sendDataInfo.detailList.splice(this.selectedDetailsIndex, 1);
               if (this.sendDataInfo.detailList.length > 1) {
                  this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
               } else {
                  this.selectedDetailsIndex = 0
               }
               let refsElTable = this.$refs.mxTableRef
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]);
            }
         } else {
            return this.$message({
               message: "暂无可删除明细",
               type: "warning",
            });
         }
      },
      // 触发提取方案
      openExComponents(e, index, entityField) {
         this.exId = e;
         this.DialogExtract = true;
         this.$set(this.extractParamsData, entityField, this.sendDataInfo[entityField])
         removeEventListener('keyup', this.keyUp)
      },
      // 获取 提取单数据
      async getExData(val) {
         for (let key in val) {
            if (key == "arrlistbychen") {
               this.sendDataInfo.detailList = val.arrlistbychen;
            } else {
               this.sendDataInfo[key] = val[key];
            }
         }
         this.sendDataInfo.detailList.forEach((item) => {
            item.psrgdRecnumber = item.collectionCount;
            item.psrgdPsupperlimit = 0;
            item.wholeNum = 0;
            item.scatNum = 0;
            item.taxAmount = 0;
            item.psrgdWaitnum = item.collectionCount;
            item.packingSpec = item.packingSpec
         });
         this.DialogExtract = false;
         addEventListener('keyup', this.keyUp)//创建监听键盘事件
         this.sendDataInfo.orderDate = this.$moment().valueOf();

         this.DialogExtract = false;
         this.$nextTick(() => {
            this.selectedDetailsIndex = 0
            this.tableNextFocus('psrgdRecnumber', 0)
            let refsElTable = this.$refs.mxTableRef
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]);
         })
      },
      getExWidth(e) {
         this.exWidth = e + "%";
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      handleDrawerClose(done) {
         this.$confirm("确认关闭？")
            .then((_) => {
               done();
            })
            .catch((_) => { });
      },
      addProductFun(formName) {
         // console.log(formName);
         this.$refs[formName].validate((valid) => {
            if (valid) {
               // console.log(valid);
               this.sendDataAction();
            } else {
               return false;
            }
         });
      },


      //确认新增
      async sendDataAction() {
         let receiptLicenseDetailList = []
         if (!this.sendDataInfo.deliOmId) {
            this.$message({
               message: "请先提取配送单",
               type: "error",
            });
            return false;
         }

         // for (let i = 0; i < this.sendDataInfo.detailList.length; i++) {
         //    const item = this.sendDataInfo.detailList[i];
         //    receiptLicenseDetailList[i] = {}
         //    receiptLicenseDetailList[i]['waitNum'] = ''
         //    for (const key in item) {
         //       if (key == 'psodId' || key == 'bgmName' || key == 'psrgdPsupperlimit' || key == 'psrgdRecnumber' || key == 'psrgdId') {
         //          receiptLicenseDetailList[i][key] = item[key]
         //       }
         //    }
         // }
         // if (receiptLicenseDetailList.length == 0) {
         //    this.$message({
         //       message: "请提取明细",
         //       type: "error",
         //    });
         //    return
         // }

         // let res = await this.$http.checkReceiptLicense({
         //    "formId": this.formDataList[2].jciId,
         //    "operateType": this.dataActionBox.actionType,
         //    "receiptLicenseDetailList": receiptLicenseDetailList
         // })
         // // console.log(res);
         // //确定弹窗
         // if (!res || res.status != 200) {
         //    //弹窗 换行提示
         //    let txtArr = res.message.split('<br/>')
         //    let newArr = []
         //    const h = this.$createElement
         //    for (const i in txtArr) {
         //       newArr.push(h('p', null, txtArr[i]))
         //    }
         //    this.$alert(h('div', null, newArr), '提示', {
         //       confirmButtonText: '确定',
         //       callback: action => { }
         //    })
         //    return false
         // }
         console.log(this.sendDataInfo, 'this.sendDataInfo');

         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.deliveryInAdd(
               this.sendDataInfo
            );
         } else {
            var responseData = await this.$http.deliveryInModifyMaster(
               this.sendDataInfo
            );
         }
         if (responseData.status == 200) {
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit('drawerCancel', 1)
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      initActionBox(sendDataInfo) {
         this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.$common.delOrderInfo(this.sendDataInfo.deliOmId)
            this.$emit('drawerCancel', 0)
            this.init()
            this.$refs[sendDataInfo].resetFields();
         }).catch(() => { });
      },
      init() {
         for (let key in this.sendDataInfo) {
            if (key == "transport") {
               for (let sonOne in this.sendDataInfo[key]) {
                  if (sonOne == 'coldPicture') {
                     this.sendDataInfo[key][sonOne] = [];
                  } else {
                     this.sendDataInfo[key][sonOne] = "";
                  }
               }
            } else if (key == "detailList") {
               this.sendDataInfo[key] = [];
            } else {
               this.sendDataInfo[key] = "";
            }
         }

         this.sendDataInfo.totalMoney = 0;
         this.sendDataInfo.totalNumber = 0;
         this.sendDataInfo.totalCount = 0;
      },
      // 提取采购订单
      async selectDataAction(data) {
         if (data) {
            var sendData = data;
            let responseData = await this.$http.extractPurchaseOrder({
               ids: sendData,
            });
            console.log(responseData);
            if (responseData.status == 200) {
               this.sendDataInfo = responseData.result;
               this.sendDataInfo.orderDate = this.$moment().valueOf();
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         }
      },
      // 选择采购员
      selectUserOne(data) {
         data.forEach((item) => {
            if (item.opmId == this.sendDataInfo.opmId) {
               this.sendDataInfo.depId = item.depId;
               this.sendDataInfo.depName = item.depName;
            }
         });
         console.log(data);
      },
      async isShowData(name, value) {
         switch (name) {
            case "supplierList":
               var dataInfo = sessionStorage.getItem("selectSupplierData");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.sendDataInfo.psrgmBuycus = dataInfo.smId;
                  this.sendDataInfo.smName = dataInfo.smName;
               }
               this.sendDataInfo.psrgmSsalesman = "";
               this.getUnitSalesmanList();
               break;

            case "cargoOwner":
               var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.sendDataInfo.coId = dataInfo.coId;
                  this.sendDataInfo.coName = dataInfo.coName;
               }
               break;
         }
      },

      openBox() {
         this.dataActionBox.actionType = this.actionData.cate
         this.formDataList = this.actionData.formData
         this.filterMainField()
         var oldData = this.actionData.oldData
         this.showTabs = this.actionData.formData[0].jciName
         // this.init();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
            this.sendDataInfo.orderDate = this.$moment().valueOf();
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(oldData))
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
            if (dataInfo.transport.coldPicture != undefined && dataInfo.transport.coldPicture != null && dataInfo.transport.coldPicture != "") {
               this.$set(this.sendDataInfo.transport, 'coldPicture', dataInfo.transport.coldPicture)
            } else {
               this.$set(this.sendDataInfo.transport, 'coldPicture', [])
            }
            this.getUnitSalesmanList();
            this.$nextTick(() => {
               if (this.sendDataInfo.detailList.length > 0)
                  this.selectedDetailsIndex = 0
               setTimeout(() => {
                  let refsElTable = this.$refs.mxTableRef
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]);
               }, 16.7)
            })
         } else {
            this.dataActionBox.boxTitle = '查看信息'
            var dataInfo = JSON.parse(JSON.stringify(oldData))
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.$refs['tree'].init(this.sendDataInfo.psrgmId)
                  this.mxHeight = this.$common.getHeight()
               }
               this.initFocus()
            }, 16.7)
            //(data中需要定义mxHeight,230可以根据明细表格有无操作按钮进行调整)
         })
      },

      // 获取业务员
      async getUnitSalesmanList() {
         this.salesmanList = [];
         let responseData = await this.$http.getUnitSalesmanList({
            ids: [this.sendDataInfo.psrgmBuycus],
         });
         if (responseData.status == 200) {
            this.salesmanList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },



      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key))
            this.tabForm[i].jurconfigform = []
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
            }
         })
         const arr = [{ entityField: "detailList" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.$set(this.sendDataInfo, "transport", {})
         mainFormList[1].jurconfigform.forEach(item => {
            if (item.fieldType == 'number') {
               this.$set(this.sendDataInfo.transport, item.entityField, 0)
            } else if (item.fieldType == 'search' && item.setField) {
               const arr = item.setField.split(',')
               arr.forEach(item1 => {
                  this.$set(this.sendDataInfo.transport, item1, "")
               })
            } else {
               if (item.entityField == 'coldPicture') {
                  this.$set(this.sendDataInfo.transport, item.entityField, [])
               } else {
                  this.$set(this.sendDataInfo.transport, item.entityField, "")
               }
            }
         })
         console.log(this.sendDataInfo.transport, "测试");

      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.ppId = "deliOmId";
      this.openBox()
      this.$http.storemastGetCurStore().then(res => {
         if (res.status == 200) {
            this.sendDataInfo.storeId = res.result.storeId
            this.sendDataInfo.stId = res.result.stId
            this.sendDataInfo.storeName = res.result.storeName
            this.extractParamsData.storeId = res.result.storeId
         }
      })


   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      addEventListener('keyup', this.keyUp)//创建监听键盘事件
   },
   //生命周期 - 销毁之前
   beforeDestroy() {
      removeEventListener('keyup', this.keyUp)
   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput()
   }, //生命周期 - 更新之后
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.formbot {
   display: flex;
   flex-direction: row;
   justify-content: center;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   /* padding-right: 20px; */
}

.mb {
   margin-bottom: 0;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
   width: 100%;
}

::v-deep .stIdSelect {
   height: auto;
}
/* 上传图片 */
.upload {
   width: 200px;
   list-style: none;
   display: flex;
   align-items: center;
   flex-wrap: wrap;
}
.upload li {
   position: relative;
   width: 42px;
   height: 42px;
   margin-right: 5px;
   margin-bottom: 5px;
   border: 1px solid #dedede;
}
.upload .active_li {
   border: none;
}
.image_label {
   display: block;
   width: 42px;
   height: 42px;
}
.upload li:last-child {
   border: none;
}
.upload li:last-child .image_label {
   border: 1px dashed #838383;
}
.upload li:last-child .image_label:hover {
   border: 1px dashed #409eff;
   cursor: pointer;
}
.upload li:last-child:hover .icon {
   color: #409eff;
}
.upload li .icon {
   color: #838383;
   font-size: 20px;
   margin: 10px 0 0 10px;
}
.del {
   display: none;
   position: absolute;
   top: 0px;
   right: 0px;
   font-size: 14px;
   z-index: 99;
   cursor: pointer;
}

.del:hover {
   color: #409eff;
}

.upload li:hover .del {
   display: inline-block;
}
::v-deep #dateinput {
   width: 200px !important;
}
::v-deep .el-date-editor.el-input {
   width: 100%;
}
::v-deep .el-image__error {
   font-size: 7px;
}
::v-deep .cus-image {
   width: 40px !important;
   height: 40px !important;
}
::v-deep .cus-image img {
   width: 40px !important;
   height: 40px !important;
}
</style>
<style>
.el-table .rowStyle {
   background: #fff7ca !important;
}
</style>